import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements AfterViewInit {
  @ViewChild('backgroundVideo', { static: false })
  backgroundVideo!: ElementRef<HTMLVideoElement>;

  ngAfterViewInit(): void {
    this.initializeVideo();
  }

  private initializeVideo(): void {
    if (this.backgroundVideo && this.backgroundVideo.nativeElement) {
      const video = this.backgroundVideo.nativeElement;

      video.muted = true;
      video.loop = true;
      video.autoplay = true;
      video.playsInline = true;

      // force play the video
      video.play().catch((error) => {
        console.log('Video autoplay failed:', error);
      });

      // video loops properly
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.play();
      });
    }
  }

  onVideoLoaded(): void {
    console.log('Video loaded successfully');
  }

  onVideoError(event: Event): void {
    console.error('Video failed to load:', event);
    // hide video container if fails to load
    const bgShapes = document.querySelector('.bg-shapes') as HTMLElement;
    if (bgShapes) {
      bgShapes.style.display = 'none';
    }
  }
}
